import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import { Button } from 'antd';

const ErrorModal = props => {
  const { isVisible, setVisible, error } = props;

  let title = 'Σφάλμα'; // Default title
  let message = 'Κάτι πήγε στραβά.'; // Default message

  if (error && error.status) {
    if (error.status === 500) {
      title = 'Ανεπιτυχής Υποβολή';
      message = 'Παρουσιάστηκε πρόβλημα στο σύστημα.';
    } else if(error.status === 400) {
      if(error.data.code === "900"){
          title = 'Ανεπιτυχής Υποβολή';
          message = <>
            Το αρχείο εξοπλισμού δεν ανταποκρίνεται στο πρότυπο. Παρακαλώ ελέγξτε ότι ισχύουν όλα τα παρακάτω:
            <ul>
              <li>Χρησιμοποιείται υποδιαστολή (κόμμα) για τον διαχωρισμό των δεκαδικών ψηφίων και όχι τελεία</li>
              <li>Δεν χρησιμοποιείται κάποιο σύμβολο (κόμμα ή τελεία) για χωρισμό των χιλιάδων</li>
              <li>Δεν υπάρχουν 2 ή παραπάνω προϊόντα με κοινό κωδικό ΕΑΝ</li>
              <li>Δεν έχει αλλαχθεί χειροκίνητα ο τύπος των κελιών του αρχείου</li>
            </ul>
          </>
      }else if(error.data.code === "901"){
          title = 'Ανεπιτυχής Υποβολή';
          message = 'Το αρχείο εξοπλισμού δεν ανταποκρίνεται στο πρότυπο. Παρακαλώ ελέγξτε ότι δεν έχει αλλαχθεί χειροκίνητα ο τύπος των κελιών του αρχείου.';
      }
      else {
          title = 'Ανεπιτυχής Υποβολή';
          message = 'Παρουσιάστηκε πρόβλημα στο σύστημα.';
      }
    } else {
        title = 'Ανεπιτυχής Υποβολή';
        message = 'Παρουσιάστηκε πρόβλημα στο σύστημα.';
    } 
  }

  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      closable={true}
      onCancel={() => setVisible(false)}
      width={400}
      footer={
        [
          <Button
            type={'default'}
            style={{width: '100%'}}
            onClick={() => setVisible(false)}
          >Κλείσιμο</Button>,
        ]
      }
      className={'invalid-modal custom-modal'}
    >
      <div className="custom-modal__header">{title}</div>
      <div className="custom-modal__body">{message}</div>
    </Modal>
  );
};

export default ErrorModal;
